import styled, { css } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

type StyledBottomElementProps = {
   $editable: boolean;
};

export const StyledBottomElement = styled(StyledFlex)<StyledBottomElementProps>`
   margin-left: auto;

   > *:only-child {
      margin-right: 8px;
      margin-top: 6px;
   }

   ${(props) =>
      props.$editable &&
      css`
         > *:only-child {
            margin-top: 6px;
            margin-right: 40px;
         }
      `}
`;

StyledBottomElement.displayName = 'StyledBottomElement';
